import { MyEvent } from "@/utils/my-event";

export const myWebsocketEvent = new MyEvent();
